import type { AuthResponse } from '@/js/types/auth.ts';
import { makeLocalizedStoreApiRoute, makeRequest } from '@/js/api/request-service.ts';

export async function login(formData: FormData) {
  return makeRequest<AuthResponse>({
    method: 'POST',
    url: makeLocalizedStoreApiRoute('auth/authenticate'),
    data: formData,
  });
}
export async function register(formData: FormData) {
  return makeRequest<AuthResponse>({
    method: 'POST',
    url: makeLocalizedStoreApiRoute('auth/register'),
    data: formData,
  });
}

export async function passwordReset(formData: FormData) {
  return makeRequest<AuthResponse>({
    method: 'POST',
    url: makeLocalizedStoreApiRoute('auth/password/reset'),
    data: formData,
  });
}

export async function passwordResetHandle(formData: FormData) {
  return makeRequest<AuthResponse>({
    method: 'POST',
    url: makeLocalizedStoreApiRoute('auth/password/reset/handle'),
    data: formData,
  });
}
